<template>


  <div class="card-517  shadow-sm rounded">

    <div class="text-center ">
      <img class="img-fluid card-517-img w-100  " :src="image" :alt="alt">
    </div>

    <div class="card-517-description">
      <slot>

        <div class="card-body bg-primary">

          <div class="title-card">
            <a class="card-text h4 font-weight-bold text-dark" href="">ضد آفتاب های MQ</a>
          </div>

          <div class="description-card mt-3">
            <p class="card-text font-size-dynamic-h6 font-weight-light text-dark">
              <a class="text-dark " href="#"> جلوگیری از ایجاد چین و چروک و نرم شدن پوست</a>
            </p>

          </div>

          <div class="button-card mt-3 font-weight-bold">

            مشاهده محصول

          </div>


        </div>


      </slot>
    </div>
  </div>


</template>


<script>
import mA from "../Tags/A.vue";
import mImg from "../Tags/Img.vue";
import {CardProps} from "./CardProps";

export default {
  name: "Card517",
  components: {mA, mImg},
  props: {
    ...CardProps,
  }
}
</script>


<style scoped>
.card-517 {
  height: 450px;
  background-color: var(--primary);


}
.card-517-img{
  aspect-ratio: 1/1;
  height: 300px;
  object-fit: cover !important;
}



</style>
